import { AuthenticationService } from './authentication.service';
import { SessionService } from '@app/shared/service/session.service';
import { Provider, APP_INITIALIZER } from '@angular/core';

const authInitializer = (auth: AuthenticationService, session: SessionService) => () => {
  const token = session.getToken();
  const isLoginAttempt = window.location.pathname.indexOf('account/sso') > -1;
  if (isLoginAttempt || auth.isTokenExpired(token)) {
    return true;
  }
  return new Promise<void>(resolve => auth.login(token).subscribe(() => resolve()));
};

export const authInitProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: authInitializer,
  deps: [AuthenticationService, SessionService],
  multi: true
};
